<template>
    <div class="layout-right" ref="layout-right">
        <div class="layout-right-top">
            <right-top bread="项目配置-项目列表"></right-top>
        </div>
        <div class="layout-right-body">
            <div class="item-box item-search">
                <search-box placeholder="单价/项目名称" :select-data="selectCategory" :btns="isMain ? searchOtherBtn : {}"
                            @click="addEvent" @search="searchEvent"
                ></search-box>
            </div>

            <div class="item-content" ref="itemContent">
                <div class="table-box">
                    <el-table :data="listData" size="medium" ref="tableData" cell-class-name="table-ceil"
                              header-cell-class-name="table-ceil" @selection-change="handleSelectionChange"
                    >
                        <el-table-column
                                type="selection"
                                width="45">
                        </el-table-column>
                        <el-table-column
                                prop="title"
                                label="项目名称"
                                width="150">
                            <template slot-scope="scope">
                                <div class="flex flex-align-center">
                                    {{scope.row.title}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="price"
                                label="价格"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="category"
                                label="分类"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="server_time"
                                label="服务时长"
                                width="80">
                            <template slot-scope="scope">
                                <span v-if="scope.row.server_time > 0">
                                    {{scope.row.server_time}}分钟
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="desc"
                                label="描述"
                                show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div class="pro-desc">
                                    {{scope.row.desc}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" v-if="isMain || !isUnified">
                            <template slot-scope="scope">
                                <el-button
                                        size="mini"
                                        type="primary"
                                        @click="handleEdit(scope.$index, scope.row)"
                                >编辑</el-button>
                                <el-button
                                        size="mini"
                                        type="danger"
                                        @click="handleDelete(scope.$index, scope.row)"
                                >删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="table-tools" v-if="isMain || !isUnified">
                        <div class="tool">
                            <el-dropdown trigger="click" placement="top-end" @command="handleCommand">
                                <span class="el-dropdown-link">
                                    <el-button size="medium">批量操作</el-button>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item icon="el-icon-edit" command="edit-category" v-if="isMain">修改分类</el-dropdown-item>
                                    <el-dropdown-item icon="el-icon-delete" command="delete">删除选中</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                </div>

                <!--<div class="page-box">-->
                    <!--<el-pagination-->
                            <!--@size-change="pageSizeChange"-->
                            <!--@current-change="pageCurrentChange"-->
                            <!--:current-page="page.nowPage"-->
                            <!--:page-sizes="page.pageSizes"-->
                            <!--:page-size="page.pageSize"-->
                            <!--layout="total, sizes, prev, pager, next, jumper"-->
                            <!--:total="page.count">-->
                    <!--</el-pagination>-->
                <!--</div>-->
            </div>

            <!--修改分类弹窗-->
            <pop-form :state="editCategoryState" width="400px">
                <div slot="title">
                    批量修改分类
                    <i class="el-icon-close fr" @click="editCategoryState = false"></i>
                </div>
                <div class="cateBody">
                    <p class="cate-line">
                        <el-radio v-model="editCategoryValue" label="">无</el-radio>
                    </p>
                    <p v-for="val in categoryList" :key="val.value" class="cate-line" v-if="categoryList.length > 0">
                        <el-radio v-model="editCategoryValue" :label="val.value">{{val.label}}</el-radio>
                    </p>
                    <p v-else class="tc">暂无分类</p>
                </div>
                <div slot="foot" class="foot-box">
                    <el-button size="small" @click="editCategoryState = false">取消</el-button>
                    <el-button type="primary" size="small" @click="handleEditCategory">确定</el-button>
                </div>
            </pop-form>

        </div>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import Menu from "@/model/Menu";
    import SearchBox from "@/model/SearchBox";
    import PopForm from "@/model/PopForm";
    import DiscountRadio from "@/model/DiscountRadio";
    import UploadThumb from "@/model/UploadThumb";
    import RightTop from "@/model/RightTop";
    export default {
        name: "AttachList",
        components: {RightTop, UploadThumb, DiscountRadio, PopForm, SearchBox, Menu},
        data: () => ({
            listData: [],
            searchData: {
                keyword: "",
                cid: "",
            },
            selectCategory: {
                value: "",
                listData: [],
            },
            searchOtherBtn: [
                {
                    label: "添加"
                }
            ],
            categoryList: [],
            page: {
                nowPage: 1,
                pageSize: 50,
                pageSizes: [50, 100, 200, 400],
                count: 0,
            },
            editCategoryState: false,
            editCategoryValue: "",
            selectedValue: [],
        }),
        computed: {
            isMain(){
                return this.$store.state.chain_option.is_main;
            },
            isUnified(){
                return this.$store.state.chain_option.is_unified_manage;
            }
        },
        mounted: function(){
            this.$store.commit("setMenuId", "6-1");

            this.loadCategory();
            this.loadListData();
        },
        methods: {
            //每页显示数量变化
            pageSizeChange: function (val) {
                this.page.pageSize = val;
                this.loadListData();
            },

            //当前页码变化
            pageCurrentChange: function (val) {
                this.page.nowPage = val;
                this.loadListData();
            },
            //加载列表数据
            loadListData: function () {
                obj.postData("product/get_pro_list", this.searchData,  res => {
                    if(res.errcode === 0){
                        this.listData = res.data;
                    }else{
                        this.listData = [];
                    }
                });
            },
            //加载分类
            loadCategory: function () {
                obj.postData("product/get_category_sort_list", {}, res => {
                    if(res.errcode === 0){
                        let cateArr = [];
                        res.data.forEach((v, k) => {
                            cateArr.push({
                                label: v.name,
                                value: v.id
                            });
                        });
                        this.categoryList = [...cateArr];
                        this.selectCategory = {
                            value: "",
                            listData: cateArr
                        };
                    }else{
                        obj.message.error(res.errdesc);
                    }
                });
            },
            //删除项目
            deleteProduct: function (id) {
                obj.postData("product/delete_pro", {id: id}, res => {
                    if(res.errcode === 0) {
                        obj.message.success("删除成功");
                        this.loadListData();
                    } else
                        obj.message.error("删除失败");
                });
            },
            //添加项目
            addEvent: function () {
                this.$root.go("product/product_info");
            },
            //编辑项目
            handleEdit: function (index, row) {
                this.$root.go("product/product_info?id="+row.id);
            },
            //删除项目按钮
            handleDelete: function (index, row) {
                this.deleteProduct(row.id);
            },
            //批量操作
            handleCommand: function (c) {
                if(this.selectedValue.length === 0){
                    obj.message.error("请先选择项目");
                    return ;
                }

                if(c === "edit-category"){
                    this.editCategoryState = true;
                }else if(c === "delete"){
                    obj.messageBox.confirm("此操作将永久删除选中项目，是否继续？", "提示", {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        if(this.selectedValue.length > 0) {
                            let idArr = [];
                            this.selectedValue.forEach((v, i) => {
                                idArr.push(v.id);
                            });
                            this.deleteProduct(idArr.join(","));
                        }else
                            obj.message.error("请先选择要删除的项目");
                    });
                }
            },
            //批量修改分类
            handleEditCategory: function () {
                if(this.selectedValue.length > 0){
                    let idArr = [];
                    this.selectedValue.forEach((v, i) => {
                       idArr.push(v.id);
                    });
                    let postData = {
                        id: idArr.join(","),
                        cid: this.editCategoryValue ? this.editCategoryValue : -1
                    };
                    obj.postData("product/set_pro_cate", postData, res => {
                        if(res.errcode === 0){
                            obj.message.success("修改成功");
                            this.editCategoryState = false;
                            this.loadListData();
                        }else{
                            obj.message.error(res.errdesc);
                        }
                    });
                }else{
                    obj.message.error("未选择要修改分类的项目");
                }
            },
            //选择变化
            handleSelectionChange: function (e) {
                this.selectedValue = e;
            },
            //搜索
            searchEvent: function (data) {
                this.searchData = {
                    keyword: data.keyword,
                    cid: data.selectVal
                };
                this.loadListData();
            }
        },
        watch: {}
    }
</script>

<style scoped>
    .pro-thumb{
        width: 46px;
        height: 46px;
    }
    .pro-desc{
        max-height: 46px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .table-tools{
        padding: 10px;
    }
    .table-tools .tool{

    }
    .foot-box{
        text-align: right;
        padding: 0 16px;
    }
    .cate-line{
        padding: 5px 20px;
    }
</style>
